import errorWithCode from './error-with-code';

export function parseBody(body: string) {
  try {
    const jsonBody = JSON.parse(body);
    return jsonBody;
  } catch (error) {
    throw errorWithCode(400, 'invalid json in body payload', { report: false });
  }
}
